import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { PartnerSelfSignupInfoFragmentDoc } from '../fragments/partnerSelfSignUp.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PartnerSelfSignupQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type PartnerSelfSignupQuery = { __typename?: 'Query', partnerSelfSignup?: { __typename?: 'PartnerSelfSignup', id: string, created_at?: string | null, panda_doc_id?: string | null, signed_at?: string | null, company_name?: string | null, company_type?: string | null, email?: string | null, phone?: string | null, package?: string | null, first_name?: string | null, last_name?: string | null, wanted_container_ids?: Array<number | null> | null, iban?: string | null, iban_name?: string | null, bic?: string | null, vat?: string | null, how_did_you_know_about_vytal?: string | null, address?: { __typename?: 'PartnerSelfSignupAddress', street?: string | null, zipcode?: string | null, city?: string | null, country?: string | null } | null, billing_address?: { __typename?: 'PartnerSelfSignupAddress', street?: string | null, zipcode?: string | null, city?: string | null, country?: string | null } | null } | null };


export const PartnerSelfSignupDocument = gql`
    query partnerSelfSignup($id: ID!) {
  partnerSelfSignup(id: $id) {
    ...PartnerSelfSignupInfo
  }
}
    ${PartnerSelfSignupInfoFragmentDoc}`;

/**
 * __usePartnerSelfSignupQuery__
 *
 * To run a query within a React component, call `usePartnerSelfSignupQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerSelfSignupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerSelfSignupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerSelfSignupQuery(baseOptions: Apollo.QueryHookOptions<PartnerSelfSignupQuery, PartnerSelfSignupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerSelfSignupQuery, PartnerSelfSignupQueryVariables>(PartnerSelfSignupDocument, options);
      }
export function usePartnerSelfSignupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerSelfSignupQuery, PartnerSelfSignupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerSelfSignupQuery, PartnerSelfSignupQueryVariables>(PartnerSelfSignupDocument, options);
        }
export type PartnerSelfSignupQueryHookResult = ReturnType<typeof usePartnerSelfSignupQuery>;
export type PartnerSelfSignupLazyQueryHookResult = ReturnType<typeof usePartnerSelfSignupLazyQuery>;
export type PartnerSelfSignupQueryResult = Apollo.QueryResult<PartnerSelfSignupQuery, PartnerSelfSignupQueryVariables>;